export const transition = <const>{
  slow: 600,
  normal: 300,
  fast: 150,
};